import { ConfigService, AppConfig } from '../services/config/config.service';
import { SlugManagerService } from '../services/slug/slug-manager.service';
import { KeycloakService } from 'keycloak-angular';

export function initializeSlugger(configService: ConfigService, slugManagerService: SlugManagerService, keycloak: KeycloakService): () => Promise<void> {
  return (): Promise<void> =>
    configService
      .loadAppConfig()
      .then((data: AppConfig) => {
        return keycloak.init({
          config: {
            url: data.keycloak.url,
            realm: data.keycloak.realm,
            clientId: data.keycloak.clientId
          },
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          }
        });
      })
      .then(() => {
        slugManagerService.loadSlugger();
      })
      .catch((error) => console.error('Error in Slugger comp', error));
}
